import Vue from 'vue';
import Router from 'vue-router';
// 

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'map-disaster',
            meta: {
                breadcrumb: [{ parent: 'แผนที่สาธารณภัย', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/DisasterMap.vue')
        },

        {
            path: '/dashboard',
            name: 'dashboard',
            meta: {
                breadcrumb: [{ parent: 'หน้าหลักสำนัก', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/Dashboard.vue')
        },

        {
            path: '/map-disaster',
            name: 'map-disaster1',
            meta: {
                breadcrumb: [{ parent: 'แผนที่สาธารณภัย', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/DisasterMap.vue')
        },

        {
            path: '/statistic-disaster',
            name: 'statistic-disaster',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/DisasterStatistic.vue')
        },
        // 
        {
            path: '/statistic/disaster',
            name: 'statistic-disaster-admin',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'ตามประเภทสาธารณภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Disaster/StatisticDisaster.vue')
        },
        {
            path: '/statistic/disasterRangeTime',
            name: 'statistic-disaster-range-time',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'จัดกลุ่มตามช่วงเวลา' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Disaster/StatisticDisasterRangeTime.vue')
        },
        {
            path: '/statistic/disasterYear',
            name: 'statistic-disaster-year',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Disaster/StatisticDisasterYear.vue')
        },
        // 
        {
            path: '/statistic/level',
            name: 'statistic-level-admin',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'ตามระดับความรุนแรง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Level/StatisticLevel.vue')
        },
        {
            path: '/statistic/levelRangeTime',
            name: 'statistic-level-range-time',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'จัดกลุ่มตามช่วงเวลา' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Level/StatisticLevelRangeTime.vue')
        },
        {
            path: '/statistic/levelYear',
            name: 'statistic-level-year',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Level/StatisticLevelYear.vue')
        },
        // 
        {
            path: '/statistic/organize',
            name: 'statistic-organize-admin',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'ตามหน่วยงานรับผิดชอบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Organize/StatisticOrganize.vue')
        },
        {
            path: '/statistic/organizeRangeTime',
            name: 'statistic-organize-range-time',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'จัดกลุ่มตามช่วงเวลา' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Organize/StatisticOrganizeRangeTime.vue')
        },
        {
            path: '/statistic/organizeResponse',
            name: 'statistic-organize-response',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'จัดกลุ่มตามหน่วยงานรับผิดชอบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Organize/StatisticOrganizeResponse.vue')
        },
        {
            path: '/statistic/organizeYear',
            name: 'statistic-organize-year',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Organize/StatisticOrganizeYear.vue')
        },
        // 
        {
            path: '/statistic/location',
            name: 'statistic-location-admin',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'ตามพี้นที่เกิดเหตุ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Location/StatisticLocation.vue')
        },
        {
            path: '/statistic/locationRangeTime',
            name: 'statistic-location-range-time',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'จัดกลุ่มตามช่วงเวลา' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Location/StatisticLocationRangeTime.vue')
        },
        {
            path: '/statistic/locationEvent',
            name: 'statistic-location-event',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'จัดกลุ่มตามพื้นที่เกิดเหตุ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Location/StatisticLocationEvent.vue')
        },
        {
            path: '/statistic/locationYear',
            name: 'statistic-location-year',
            meta: {
                breadcrumb: [{ parent: 'สถิติสาธารณภัย', label: 'เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี' }]
            },
            exact: true,
            component: () =>
                import ('./components/Statistic/Location/StatisticLocationYear.vue')
        },
        // 
        {
            path: '/information',
            name: 'information',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Information.vue')
        },

        {
            path: '/information/system',
            name: 'information-system',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลระบบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/System/InformationSystem.vue')
        },
        {
            path: '/information/system/general',
            name: 'information-general',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลพื้นฐานระบบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/System/InformationGeneral.vue')
        },

        {
            path: '/information/system/country',
            name: 'information-country',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลจังหวัด, อำเภอ, ตำบล' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/System/InformationCountry.vue')
        },

        {
            path: '/information/initial',
            name: 'information-initial',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลตั้งต้น' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationInitial.vue')
        },

        {
            path: '/information/initial/evacuation',
            name: 'information-evacuation',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลพื้นที่อพยพ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationEvacuationArea.vue')
        },

        {
            path: '/information/initial/risk_level',
            name: 'information-risk-level',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลระดับความเสี่ยง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationRiskLevel.vue')
        },

        {
            path: '/information/initial/risk_area',
            name: 'information-risk-area',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลพื้นที่เสี่ยงภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationRiskArea.vue')
        },

        {
            path: '/information/initial/organization',
            name: 'information-organization',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลหน่วยงาน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationOrganization.vue')
        },

        {
            path: '/information/initial/disaster_prevent',
            name: 'information-disaster-prevent',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationDisasterPrevent.vue')
        },

        {
            path: '/information/initial/course',
            name: 'information-course',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลหลักสูตรการฝึกอบรม' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationTrainingCourse.vue')
        },

        {
            path: '/information/initial/man_power',
            name: 'information-man-power',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลกำลังคน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationManPower.vue')
        },

        {
            path: '/information/initial/device',
            name: 'information-device',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลอุปกรณ์สำนักงาน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationDevice.vue')
        },

        {
            path: '/information/initial/incident',
            name: 'information-incident',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลชุดเผชิญเหตุ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationIncident.vue')
        },

        {
            path: '/information/initial/equipment_vehicle',
            name: 'information-equipment-vehicle',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationEquipmentVehicle.vue')
        },

        {
            path: '/information/initial/building',
            name: 'information-building',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลอาคาร/สิ่งปลูกสร้าง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationBuilding.vue')
        },

        {
            path: '/information/initial/UN_Number',
            name: 'information-UNnumber',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'UN Number' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationUNNumber.vue')
        },

        {
            path: '/information/initial/FireHydrant',
            name: 'information-FireHydrant',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลหัวจ่ายน้ำดับเพลิง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationFireHydrant.vue')
        },
        {
            path: '/information/initial/Extinguisher',
            name: 'information-Extinguisher',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลถังดับเพลิง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationExtinguisher.vue')
        },
      
        // {
        //     path: '/information/initial/Extinguisher-test',
        //     name: 'information-Extinguisher',
        //     meta: {
        //         breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลถังดับเพลิง' }]
        //     },
        //     exact: true,
        //     component: () =>
        //         import ('./components/Information/Initial/InformationExtinguisher_down.vue')
        // },
        
        {
            path: '/information/initial/Community',
            name: 'information-Community',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลชุมชน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationCommunity.vue')
        },

        {
            path: '/information/initial/FireStation',
            name: 'information-FireStation',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลสถานีดับเพลิงและกู้ภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationFireStation.vue')
        },

        {
            path: '/information/initial/Consumables',
            name: 'information-consumables',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'เครื่องอุปโภค บริโภค' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationConsumables.vue')
        },

        {
            path: '/information/disaster',
            name: 'information-disaster',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลสาธารณภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/DisasterInformation.vue')
        },

        {
            path: '/information/disaster/people',
            name: 'information-disaster-people',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลสาธารณภัย (รับแจ้งจากประชาชน)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/DisasterPeopleInformation.vue')
        },

        {
            path: '/information/victim',
            name: 'information-victim',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลผู้ประสบภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/VictimInformation.vue')
        },

        {
            path: '/information/population',
            name: 'information-population',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'สถิติจำนวนบุคลากร' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/PopulationInformation.vue')
        },

        {
            path: '/information/administrator',
            name: 'information-administrator',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลผู้ดูแลระบบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Administrator/InformationAdministrator.vue')
        },

        {
            path: '/information/administrator/permission',
            name: 'information-permission',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลระดับสิทธิ์' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Administrator/InformationPermissionLevel.vue')
        },

        {
            path: '/information/administrator/user',
            name: 'information-user',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลผู้ใช้งานระบบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Administrator/InformationSystemUser.vue')
        },

        {
            path: '/information/administrator/menu',
            name: 'information-menu',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลเมนูการใช้งาน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Administrator/InformationUsageMenu.vue')
        },

        {
            path: '/information/administrator/configuration',
            name: 'information-configuration',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'Configuration' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Administrator/InformationConfiguration.vue')
        },

        {
            path: '/report/officer',
            name: 'report-officer',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ข้อมูลกำลังคน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/ManPower/ReportOfficer.vue')
        },

        {
            path: '/report/officerDetail',
            name: 'report-officer-detail',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายละเอียดข้อมูลเจ้าหน้าที่' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/ManPower/ReportOfficerDetail.vue')
        },
        {
            path: '/report/officerAmount',
            name: 'report-officer-amount',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'สรุปจำนวนเจ้าหน้าที่' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/ManPower/ReportOfficerAmount.vue')
        },
        // 
        {
            path: '/report/equipment',
            name: 'report-equipment',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ข้อมูลเครื่องมือฯ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Equipment/ReportEquipment.vue')
        },
        {
            path: '/report/equipmentDetail',
            name: 'report-equipment-detail',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายละเอียดข้อมูลเครื่องมือฯ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Equipment/ReportEquipmentDetail.vue')
        },
        {
            path: '/report/equipmentMaintenance',
            name: 'report-equipment-maintenance',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ประวัติการซ่อมบำรุง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Equipment/ReportEquipmentMaintenance.vue')
        },
        {
            path: '/report/equipmentBorrowing',
            name: 'report-equipment-borrowing',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ประวัติการยืม' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Equipment/ReportEquipmentBorrowing.vue')
        },
        {
            path: '/report/equipmentInvestigation',
            name: 'report-equipment-investigation',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'สรุปรายงานความพร้อมเครื่องมือ อุปกรณ์/ยานพาหนะ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Equipment/ReportEquipmentInvestigation.vue')
        },
        //

        {
            path: '/report/riskarea',
            name: 'report-riskarea',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ข้อมูลพื้นที่เสี่ยงภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/RiskArea/ReportRiskArea.vue')
        },
        {
            path: '/report/riskareaAmount',
            name: 'report-risk-area-amount',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'สรุปจำนวนพื้นที่เสี่ยงภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/RiskArea/ReportRiskAreaAmount.vue')
        },
        {
            path: '/report/riskareaGraph',
            name: 'report-risk-area-graph',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟสรุปจำนวนพื้นที่เสี่ยงภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/RiskArea/ReportRiskAreaGraph.vue')
        },
        // 
        {
            path: '/report/building',
            name: 'report-building',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ข้อมูลอาคาร' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Building/ReportBuilding.vue')
        },
        // 
        {
            path: '/report/disaster',
            name: 'report-disaster',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ข้อมูลสาธารณภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisaster.vue')
        },
        {
            path: '/report/disasterDetail',
            name: 'report-disaster-detail',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายละเอียดข้อมูล' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisasterDetail.vue')
        },
        {
            path: '/report/disasterAmount',
            name: 'report-disaster-amount',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'สรุปจำนวนเหตุการณ์' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisasterAmount.vue')
        },
        {
            path: '/report/disasterGraphMonth',
            name: 'report-disaster-graph-month',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟสรุปตามประเภทสาธารณภัย (รายเดือน)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisasterGraphMonth.vue')
        },
        {
            path: '/report/disasterGraphYear',
            name: 'report-disaster-graph-year',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟสรุปตามประเภทสาธารณภัย (รายปี)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisasterGraphYear.vue')
        },
        {
            path: '/report/disasterLocationGraphMonth',
            name: 'report-disaster-location-graph-month',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟสรุปตามพื้นที่เกิดเหตุ (รายเดือน)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisasterLocationGraphMonth.vue')
        },
        {
            path: '/report/disasterLocationGraphYear',
            name: 'report-disaster-location-graph-year',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟสรุปตามพื้นที่เกิดเหตุ (รายปี)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Disaster/ReportDisasterLocationGraphYear.vue')
        },
        // 
        {
            path: '/report/victim',
            name: 'report-victim',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'ข้อมูลผู้ประสบภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictim.vue')
        },
        {
            path: '/report/victimDetail',
            name: 'report-victim-detail',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายละเอียด' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimDetail.vue')
        },
        {
            path: '/report/victimAmount',
            name: 'report-victim-amount',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'สรุปจำนวนผู้ประสบภัย' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimAmount.vue')
        },
        {
            path: '/report/victimDisasterGraphMonth',
            name: 'report-victim-disaster-graph-month',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟตามประเภทสาธารณภัย (รายเดือน)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimDisasterGraphMonth.vue')
        },
        {
            path: '/report/victimDisasterGraphYear',
            name: 'report-victim-disaster-graph-year',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟตามประเภทสาธารณภัย (รายปี)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimDisasterGraphYear.vue')
        },
        {
            path: '/report/victimLocationGraphMonth',
            name: 'report-victim-location-graph-month',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟตามพื้นที่เกิดเหตุ (รายเดือน)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimLocationGraphMonth.vue')
        },
        {
            path: '/report/victimLocationGraphYear',
            name: 'report-victim-location-graph-year',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'กราฟตามพื้นที่เกิดเหตุ (รายปี)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimLocationGraphYear.vue')
        },
        {
            path: '/report/victimConclusion',
            name: 'report-victim-conclusion',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'สรุปมูลค่าขอความช่วยเหลือ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Victim/ReportVictimConclusion.vue')
        },
        // 
        {
            path: '/report/daily',
            name: 'report-daily',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายงานประจำวัน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Daily/ReportDaily.vue')
        },
        {
            path: '/report/dailyFire',
            name: 'report-daily-fire',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายงานเหตุเพลิงไหม้ (ว.๘/๐๐๑)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Daily/ReportDailyFire.vue')
        },
        {
            path: '/report/dailyDisaster',
            name: 'report-daily-disaster',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายงานเหตุสาธารณภัยและบริการประชาชน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Daily/ReportDailyDisaster.vue')
        },
        // \
        
        {
            path: '/report/logs',
            name: 'report-logs',
            meta: {
                breadcrumb: [{ parent: 'รายงาน', label: 'รายงานข้อมูลการใช้งานระบบ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Report/Logs/ReportLogs.vue')
        },

        {
            path: '/suggestion',
            name: 'suggestion',
            meta: {
                breadcrumb: [{ parent: 'ข้อเสนอแนะ', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/Suggestion.vue')
        },

        {
            path: '/update',
            name: 'update-info',
            meta: {
                breadcrumb: [{ parent: 'รายการข้อมูลที่ต้องปรับปรุง', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/UpdateInfo.vue')
        },
        {
            path: '/manual/addManual',
            name: 'addManual',
            meta: {
                breadcrumb: [{ parent: 'คู่มือการใช้งาน', label: 'เพิ่มข้อมูลการใช้งาน' }]
            },
            exact: true,
            component: () =>
                import ('./components/Manual/AddManual.vue')
        },
        {
            path: '/overview',
            name: 'overview',
            meta: {
                breadcrumb: [{ parent: 'ภาพรวม', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/Overview.vue')
        },


        {
            path: '/information/initial/volunteer',
            name: 'information-volunteer',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลอาสาสมัครป้องกันภัยฝ่ายพลเรือน (อปพร.)' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationVolunteerNew.vue')
        },


        {
            path: '/information/initial/volunteer/bangkok',
            name: 'information-volunteer',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลทะเบียนอาสาสมัครในพื้นที่กรุงเทพมหานคร' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationVolunteerBangkok.vue')
        },
        
        {
            path: '/information/initial/public-organization',
            name: 'information-public-organization',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลสถานประกอบการ' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationPublicOrganization.vue')
        },

        {
            path: '/information/initial/ev-stations',
            name: 'information-ev-stations',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลสถานีชาร์จรถยนต์ไฟฟ้า' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationEVStaion.vue')
        },
        {
            path: '/information/initial/volunteer-rescue',
            name: 'information-volunteer-rescue',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลจุดอาสาสมัคร' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/InformationVolunteerRescue.vue')
        },

        {
            path: '/public/information/initial/fire-hydrant/details',
            name: 'information-ev-stations',
            meta: {
                breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลรายละเอียดหัวจ่ายดับเพลิง' }]
            },
            exact: true,
            component: () =>
                import ('./components/Information/Initial/FirehydrantDetails.vue')
        },
        {
            path: '/cookie-policy',
            name: 'cookie-policy',
            meta: {
                breadcrumb: [{ parent: 'นโยบายคุกกี้ (Cookie Policy)', label: '' }]
            },
            exact: true,
            component: () =>
                import ('./components/CookiePolicyPage.vue')
        },

        
{
    path: '/public/information/initial/Extinguisher',
    name: 'information-Extinguisher-details',
    meta: {
        breadcrumb: [{ parent: 'ข้อมูลสารสนเทศ', label: 'ข้อมูลรายละเอียดถังดับเพลิง' }]
    },
    exact: true,
    component: () =>
        import('./components/Information/Initial/ExtinguisherDetails.vue'),
    beforeEnter: (to, from, next) => {
        next()
    },
    beforeRouteLeave: (to, from, next) => {
        if (window.history.state && window.history.state.position > 1) {
            next('/map-disaster')
        } else {
            next('/map-disaster')
        }
    }
}
        

    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});